import React, { Component } from "react";
import { Helmet } from "react-helmet";
import Layout from "../../../components/layout";
import { ReduxConnect } from "../../../../toolkit/decorators/Artifact";
import {
  ConfiguracionPlantillaDispatcher,
  configuracionPlantillaDispatcher
} from "./ConfiguracionPlantilla.dispatcher";
import {
  ConfiguracionPlantillaStore,
  configuracionPlantillaStore
} from "./ConfiguracionPlantilla.store";
import ConfiguracionPlantillaComponent from "../../../components/comisionesMembresiaConfiguracion/configuracionPlantilla";

interface Props
  extends ConfiguracionPlantillaStore,
    ConfiguracionPlantillaDispatcher {}

@ReduxConnect(configuracionPlantillaStore, configuracionPlantillaDispatcher)
export default class ConfiguracionPlantillaContainer extends Component<Props> {
  render() {
    return (
      <main>
        <Layout>
          <Helmet title="Configuración de Plantilla" />
          <ConfiguracionPlantillaComponent {...this.props} />
        </Layout>
      </main>
    );
  }
}
